import { useMemoWithDeps } from '@entegral/helpers.react/hooks/memo-with-deps';
import { mergePinPointsWithinDistance } from '@entegral/domains.pin-point/logic/merge-within-distance';

export function usePropertiesGroups(properties, zoom) {
  return useMemoWithDeps(composeGroups, [], [properties, zoom]);
}

function composeGroups(pinPoints, zoom, hydrateGroupStrategy, hydrationContext) {
  let mergeDistance = getMergeDistance(zoom);
  let groups = mergePinPointsWithinDistance(pinPoints, mergeDistance);

  groups.forEach(x => {
    x.isDetailed = isDetailedGroup(x);
    if (hydrateGroupStrategy) hydrateGroupStrategy(x, zoom, hydrationContext);
  });

  return groups;
}

function isDetailedGroup(group) {
  let isCollapsedBounds = (
    group.bounds
    && group.bounds[0][0] === group.bounds[1][0]
    && group.bounds[0][1] === group.bounds[1][1]
  );

  let isSingleArea = group.items.length === 1;

  return isCollapsedBounds || isSingleArea;
}

function getMergeDistance(zoom) {
  if (zoom < 3.5) return 300_000;
  if (zoom < 4) return 200_000;
  if (zoom < 5) return 150_000;
  if (zoom < 6) return 75_000;
  if (zoom < 7) return 40_000;
  if (zoom < 8) return 20_000;
  if (zoom < 9) return 10_000;
  if (zoom < 9.5) return 5000;
  if (zoom < 10) return 4000;
  if (zoom < 10.5) return 3000;
  if (zoom < 11) return 2000;
  if (zoom < 11.5) return 1500;
  if (zoom < 12) return 1250;
  if (zoom < 12.5) return 1100;
  if (zoom < 13) return 750;
  if (zoom < 13.5) return 600;
  if (zoom < 14) return 500;
  if (zoom < 14.5) return 400;
  if (zoom < 15) return 300;
  if (zoom < 15.5) return 250;
  if (zoom < 16) return 200;
  if (zoom < 16.5) return 100;
  if (zoom < 17) return 50;
  if (zoom < 17.5) return 30;

  return 0;
}
